import { render, staticRenderFns } from "./Office-New-Request-Step4.vue?vue&type=template&id=707ee61c&scoped=true&"
import script from "./Office-New-Request-Step4.vue?vue&type=script&lang=js&"
export * from "./Office-New-Request-Step4.vue?vue&type=script&lang=js&"
import style0 from "./Office-New-Request-Step4.vue?vue&type=style&index=0&id=707ee61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ee61c",
  null
  
)

export default component.exports